import * as React from 'react';
import { ProgressWrapper, AnimatedCircle } from './FormProgress.s';
import range = require('lodash/range');

type FormProgressProps = {
  progress: number;
  size?: number;
};

export const FormProgress = (props: FormProgressProps) => {
  const { size = 5, progress } = props;
  const width = 280;
  const height = 19;
  const borderSize = 1;
  const margin = 1;
  const circleRadius = (height - (borderSize * 2 + margin * 2)) / 2;
  const partSize = circleRadius + borderSize + margin;
  const devideWidth = width - 2 * partSize;
  const middleYPos = height / 2;
  const circleXPosIncrement = devideWidth / (size - 1);
  return (
    <ProgressWrapper>
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          {React.Children.toArray([
            <rect
              key="react"
              fill="#CACACA"
              x={middleYPos - 0.5}
              y={middleYPos - 0.5}
              width={devideWidth + 2}
              height={1}
            />,
            ...range(size).map(index => (
              <AnimatedCircle
                stroke="#7B28C8"
                strokeWidth={borderSize}
                fill={index <= progress ? '#7B28C8' : '#FFF'}
                cy={middleYPos}
                cx={partSize + index * circleXPosIncrement}
                r={circleRadius}
              />
            )),
          ])}
        </g>
      </svg>
    </ProgressWrapper>
  );
};



// WEBPACK FOOTER //
// src/app/src/components/FormProgress/FormProgress.tsx